import gql from 'graphql-tag';

export const searchQuery = gql`
  query SearchQuery($query: String!, $notebookId: ID!) {
    search(query: $query, notebookId: $notebookId) {
      noteCount
      subjectCount
      trackerCount
      edges {
        cursor
        node {
          __typename
          ... on Note {
            id
            content
          }
          ... on Tracker {
            id
            name
          }
          ... on Subject {
            id
            name
          }
        }
      }
    }
  }
`;
